import { render, staticRenderFns } from "./ShareholderAwardLog.vue?vue&type=template&id=79bd9cec&scoped=true&"
import script from "./ShareholderAwardLog.vue?vue&type=script&lang=js&"
export * from "./ShareholderAwardLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd9cec",
  null
  
)

export default component.exports